<div class="part1">

    <div class="row content">
        <div class="col-5 float-left">
            <a class="btn connect-btn" data-aos="fade-left" data-aos-duration="1000"
                href="https://thebrainswar.com/User" target="_blank">
                <img [src]="baseURL + 'arrow-icn.png'">
                התחברות למשחק
            </a>
            <a class="btn google-play-btn" data-aos="fade-left" data-aos-duration="1000"
                href="https://play.google.com/store/apps/details?id=com.milchamt_mochot&hl=iw&gl=US" target="_blank">
                <!-- href="https://play.google.com/store/apps/details?id=com.milchamt_mochot" target="_blank"> -->
                <img [src]="baseURL + 'google-play-icn.png'">
                GooglePlay -להורדה מ
            </a>
            <div class="content-txt" data-aos="fade-up">
                <label class="txt-1" data-aos="zoom-out-down">
                    אוהבים מתח ואתגרים?
                </label>

                <label class="txt-2" data-aos="zoom-out-up">
                    בואו לשחק יחד טריוויה מרחוק
                </label>

                <p class="txt-3" data-aos="zoom-out-up">
                    גלו עולם שלם ומלהיב, חוויה חדשנית שעוד לא הכרתם!
                    <br>
                    משחק טריוויה משותף, בטכנולוגיה יחודית ופורצת דרך:
                    <br>
                    כל אחד - מכל מקום - בכל מכשיר: ווב/אפליקציה/טלפון
                </p>

                <img class="play-btn" [src]="baseURL + 'play-btn.png'" (click)="bShowVideo=true">
            </div>
        </div>
    </div>

    <a class="btn whatsapp-lnk float-left" data-aos1="fade-right" data-aos-duration="1000" href="
    https://api.whatsapp.com/send?phone=972527693131" target="_blank">
        זמינים בוואצאפ
        <img [src]="baseURL + 'whatsapp-icn.png'">
    </a>
    <button class="btn users-site-lnk float-right" data-aos="fade-left" data-aos-duration="1000">
        מוזמנים לשחק :)
    </button>


    <div class="my-modal" id="exampleModalCenter" *ngIf="bShowVideo">

        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button *ngIf="bShowVideo" type="button" class="btn btn-secondary btn-close-popup"
                    (click)="bShowVideo=false">X</button>
                <div class="modal-body" style="background-color: #000000;">
                    <mm-popup-video></mm-popup-video>
                </div>

            </div>
        </div>
    </div>
</div>